/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServerReference,
    LDAPServerReferenceFromJSON,
    LDAPServerReferenceFromJSONTyped,
    LDAPServerReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsUserDetailPartialUpdate
 */
export interface ElementsUserDetailPartialUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    allowChangingPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    allowWanLogin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    email?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserDetailPartialUpdate
     */
    expiry?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetailPartialUpdate
     */
    fmBookmarks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    fullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetailPartialUpdate
     */
    gid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetailPartialUpdate
     */
    home?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    isCloud?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    isCloudDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    language?: ElementsUserDetailPartialUpdateLanguageEnum;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUserDetailPartialUpdate
     */
    lastSeen?: Date | null;
    /**
     * 
     * @type {LDAPServerReference}
     * @memberof ElementsUserDetailPartialUpdate
     */
    ldap?: LDAPServerReference;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    ldapDn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    passwordChangeRequired?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserDetailPartialUpdate
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetailPartialUpdate
     */
    shaperCeiling?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetailPartialUpdate
     */
    shaperRate?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserDetailPartialUpdate
     */
    totpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserDetailPartialUpdate
     */
    uid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    unixUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserDetailPartialUpdate
     */
    username?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ElementsUserDetailPartialUpdate
     */
    groups?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserDetailPartialUpdateLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserDetailPartialUpdateFromJSON(json: any): ElementsUserDetailPartialUpdate {
    return ElementsUserDetailPartialUpdateFromJSONTyped(json, false);
}

export function ElementsUserDetailPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserDetailPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowChangingPassword': !exists(json, 'allow_changing_password') ? undefined : json['allow_changing_password'],
        'allowWanLogin': !exists(json, 'allow_wan_login') ? undefined : json['allow_wan_login'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'expiry': !exists(json, 'expiry') ? undefined : (json['expiry'] === null ? null : new Date(json['expiry'])),
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'home': !exists(json, 'home') ? undefined : json['home'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'isCloudDefault': !exists(json, 'is_cloud_default') ? undefined : json['is_cloud_default'],
        'isEnabled': !exists(json, 'is_enabled') ? undefined : json['is_enabled'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
        'ldap': !exists(json, 'ldap') ? undefined : LDAPServerReferenceFromJSON(json['ldap']),
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'passwordChangeRequired': !exists(json, 'password_change_required') ? undefined : json['password_change_required'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'shaperCeiling': !exists(json, 'shaper_ceiling') ? undefined : json['shaper_ceiling'],
        'shaperRate': !exists(json, 'shaper_rate') ? undefined : json['shaper_rate'],
        'totpEnabled': !exists(json, 'totp_enabled') ? undefined : json['totp_enabled'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'unixUsername': !exists(json, 'unix_username') ? undefined : json['unix_username'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
    };
}

export function ElementsUserDetailPartialUpdateToJSON(value?: ElementsUserDetailPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allow_changing_password': value.allowChangingPassword,
        'allow_wan_login': value.allowWanLogin,
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'email': value.email,
        'expiry': value.expiry === undefined ? undefined : (value.expiry === null ? null : value.expiry.toISOString()),
        'fm_bookmarks': value.fmBookmarks,
        'full_name': value.fullName,
        'gid': value.gid,
        'home': value.home,
        'is_external': value.isExternal,
        'is_cloud': value.isCloud,
        'is_cloud_default': value.isCloudDefault,
        'is_enabled': value.isEnabled,
        'language': value.language,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen === null ? null : value.lastSeen.toISOString()),
        'ldap': LDAPServerReferenceToJSON(value.ldap),
        'ldap_dn': value.ldapDn,
        'password_change_required': value.passwordChangeRequired,
        'permissions': value.permissions,
        'shaper_ceiling': value.shaperCeiling,
        'shaper_rate': value.shaperRate,
        'totp_enabled': value.totpEnabled,
        'uid': value.uid,
        'unix_username': value.unixUsername,
        'username': value.username,
        'groups': value.groups,
    };
}


